import * as React from 'react';

import { getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { EParkingType } from '../../../../../api-models/common/json_query';
import { Parking } from '../../../components/advancedFilters/Parking';
import { useFiltersContext } from '../../../utils/useFiltersContext';
import { useOfferType } from '../../../utils/useOfferType';

export const ParkingContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const offerType = useOfferType();
  const parkingType = getTermsValue('parking_type')(jsonQuery);

  const handleChange = React.useCallback(
    (parkingType: EParkingType[] | null) => {
      onChange({ action: 'setParkingType', arguments: [parkingType] });
    },
    [onChange],
  );

  return (
    <Parking offerType={offerType} value={parkingType as NonEmptyArray<EParkingType> | null} onChange={handleChange} />
  );
};
